package com.appcreator.client.firebase.auth

import androidx.compose.runtime.Composable
import com.appcreator.blueprint.core.EnvStore
import com.appcreator.blueprint.firebase.auth.FirebaseAuthSignInWithGoogle
import com.appcreator.compose.actions.Performer
import com.appcreator.compose.di.Container
import com.appcreator.compose.events.LoginEvent
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.auth.externals.GoogleAuthProvider
import dev.gitlive.firebase.auth.externals.signInWithPopup
import dev.gitlive.firebase.auth.js
import kotlin.coroutines.resume
import kotlin.coroutines.resumeWithException
import kotlin.coroutines.suspendCoroutine

@Composable
actual fun signInWithGooglePerformerDeferred(action: FirebaseAuthSignInWithGoogle): Performer.Deferred {
    return object : Performer.Deferred {
        override suspend fun perform(envStore: EnvStore) {
            val provider = GoogleAuthProvider()
            val result = suspendCoroutine { continuation ->
                signInWithPopup(Firebase.auth.js, provider)
                    .then {
                        continuation.resume(it.user)
                    }
                    .catch {
                        continuation.resumeWithException(it)
                    }
            }
            Container.sendEvent(LoginEvent(result.uid, result.email, result.displayName))
        }
    }
}